export function ensureGoogletagCommandQueue(googletag: any): any {
  const value = googletag || {};

  if (typeof value.cmd?.push !== 'function') {
    value.cmd = [];
  }

  return value;
}
